import { FC, ReactNode, useMemo } from 'react'
import styles from 'components/features/socialFeed/SocialInsightCard/SocialInsightCard.styl'
import cn from 'classnames'

type SocialInsightCardProps = {
  noPadding?: boolean
  footerChild?: ReactNode
}

export const SocialInsightCard: FC<SocialInsightCardProps> = (props) => {
  const { children, noPadding } = props

  const footerChild = useMemo(() => {
    if (!props.footerChild) {
      return null
    }

    return (
      <div className={ styles.footerWrapper }>
        { props.footerChild }
      </div>
    )
  }, [props.footerChild])

  return (
    <div className={ styles.socialInsightCard }>
      <div className={ cn(styles.inner, noPadding && styles.noPadding) }>
        { children }
      </div>
      { footerChild }
    </div>
  )
}
